import * as PIXI from 'pixi.js'

const btnSize = 30
const minSize = 10
const fontSize = 36
let screenOffsetY = 40
const fix = 1
const innerHeight = window.innerHeight

class MyPIXIText {
  constructor (app, data, isPhone) {
    if (isPhone) {
      screenOffsetY = 0
    }
    this.isPhone = isPhone
    this.visible = true
    this._draggin = false
    this._frame = null
    this._type = 'text'

    const container = new PIXI.Container()

    if (data) {
      container.x = data.x
      container.y = data.y
      container.angle = data.angle
    } else {
      container.x = 0
      container.y = 0
    }

    let style = null
    if (data) {
      style = new PIXI.TextStyle({
        fontFamily: data.fontFamily,
        fontSize: data.fontSize,
        fontWeight: data.fontWeight,
        fontStyle: data.fontStyle,
        fill: data.color
      })
    } else {
      style = new PIXI.TextStyle({
        fontStyle: 'normal',
        fontFamily: 'Arial',
        fontSize: fontSize,
        fontWeight: 'normal',
        fill: 0x00000
      })
    }
    let text = null
    if (data) {
      text = new PIXI.Text(data.text, style)
    } else {
      text = new PIXI.Text('Text', style)
    }
    this.text = text
    text.anchor.set(0.5)
    container.addChild(text)

    const input = document.createElement('input')
    input.value = 'Text'
    input.type = 'text'
    input.style.resize = 'none'
    input.style.overflow = 'hidden'
    input.style.position = 'absolute'
    input.style.textAlign = 'justify'
    input.style.zIndex = '999'
    input.style.outline = 'none'
    input.style.border = 'none'
    input.style.padding = '0'
    input.style.margin = '0'
    input.style.backgroundColor = 'transparent'
    input.style.pointerEvents = 'none'
    input.style.display = 'none'
    input.addEventListener('keydown', (e) => {
      if (e.keyCode === 13) {
        this.blurAction()
        e.preventDefault()
      }
    })
    input.addEventListener('input', (e) => {
      this.text.text = e.target.value
      // 修改input width和left
      input.style.width = this.text.width + 'px'
      input.style.height = this.text.height + 'px'
      input.style.lineHeight = this.text.height + 'px'
      input.style.left = (window.innerWidth - this.text.width) * 0.5 + this.container.x + 'px'
      input.style.top = (innerHeight - this.text.height * fix - screenOffsetY) * 0.5 + this.container.y + 'px'
      // 更新frame
      this.change()
    })
    input.addEventListener('blur', () => {
      this.blurAction()
    })
    document.body.appendChild(input)
    this.input = input

    const frame = new PIXI.Container()
    frame.visible = false
    this._frame = frame
    container.addChild(frame)

    const bg = new PIXI.Sprite(PIXI.Texture.EMPTY)
    // bg.tint = 0xff0000
    // bg.alpha = 0.3
    bg.anchor.set(0.5)
    bg.width = text.width
    bg.height = text.height
    bg.interactive = true
    bg.buttonMode = true
    bg.on('pointerdown', (e) => {
      if (this.select) {
        this.select(this)
      }
      this._dragging = true
      frame.visible = true
      bg._x = container.x
      bg._y = container.y
      bg._startx = e.data.getLocalPosition(bg.parent.parent).x
      bg._starty = e.data.getLocalPosition(bg.parent.parent).y
    })
    bg.on('pointermove', (e) => {
      if (!this._dragging) return
      const x = e.data.getLocalPosition(bg.parent.parent).x
      const y = e.data.getLocalPosition(bg.parent.parent).y
      container.x = bg._x + x - bg._startx
      container.y = bg._y + y - bg._starty
      if (this.update) {
        this.update()
      }
    })
    bg.on('pointerup', () => {
      this._dragging = false
    })
    bg.on('pointerupoutside', () => {
      this._dragging = false
      frame.visible = false
    })
    container.addChild(bg)

    // 0-红线框
    const lineContainer = new PIXI.Container()
    frame.addChild(lineContainer)
    const line = new PIXI.Graphics()
    line.lineStyle(2, 0xffffff, 1)
    line.moveTo(-text.width * 0.5, -text.height * 0.5)
    line.lineTo(-text.width * 0.5, text.height * 0.5)
    line.lineTo(text.width * 0.5, text.height * 0.5)
    line.lineTo(text.width * 0.5, -text.height * 0.5)
    line.lineTo(-text.width * 0.5, -text.height * 0.5)
    lineContainer.addChild(line)

    // 1
    const removeLineContainer = new PIXI.Container()
    frame.addChild(removeLineContainer)
    const removeLine = new PIXI.Graphics()
    removeLine.lineStyle(2, 0xffffff, 1)
    removeLine.moveTo(-text.width * 0.5, 0)
    removeLine.lineTo(-text.width * 0.5 - btnSize * 0.75, 0)
    removeLineContainer.addChild(removeLine)

    // 2
    const removeBG = PIXI.Sprite.from('./circle.svg')
    removeBG.tint = 0x0485d5
    removeBG.anchor.set(0.5)
    removeBG.width = btnSize
    removeBG.height = btnSize
    removeBG.x = -text.width * 0.5 - btnSize * 0.75
    removeBG.y = 0
    removeBG.interactive = true
    removeBG.buttonMode = true
    removeBG.on('pointerdown', () => {
      this.removeAction()
    })
    frame.addChild(removeBG)

    // 3
    const remove = PIXI.Sprite.from('./delete.svg')
    remove.anchor.set(0.5)
    remove.width = btnSize * 0.5
    remove.height = btnSize * 0.5
    remove.x = -text.width * 0.5 - btnSize * 0.75
    remove.y = 0
    frame.addChild(remove)

    // 4
    const zoomLineContainer = new PIXI.Container()
    const zoomLine = new PIXI.Graphics()
    zoomLineContainer.addChild(zoomLine)
    zoomLine.lineStyle(2, 0xffffff, 1)
    zoomLine.moveTo(text.width * 0.5, 0)
    zoomLine.lineTo(text.width * 0.5 + btnSize * 0.75, 0)
    frame.addChild(zoomLineContainer)

    // 5
    const zoomBG = PIXI.Sprite.from('./circle.svg')
    zoomBG.tint = 0x0485d5
    zoomBG.anchor.set(0.5)
    zoomBG.width = btnSize
    zoomBG.height = btnSize
    zoomBG.x = text.width * 0.5 + btnSize * 0.75
    zoomBG.y = 0
    zoomBG.interactive = true
    zoomBG.buttonMode = true
    zoomBG.on('pointerdown', (e) => {
      this.blurAction()
      this._zooming = true
      zoomBG._startSize = text.style.fontSize
      zoomBG._startx = e.data.getLocalPosition(bg.parent.parent).x
    })
    zoomBG.on('pointermove', (e) => {
      if (!this._zooming) return
      let size = zoomBG._startSize + (e.data.getLocalPosition(bg.parent.parent).x - zoomBG._startx) * 0.5
      if (size < minSize) {
        size = minSize
      }
      text.style.fontSize = size
      this.change()
    })
    zoomBG.on('pointerup', () => {
      this._zooming = false
    })
    zoomBG.on('pointerupoutside', () => {
      this._zooming = false
    })
    frame.addChild(zoomBG)

    // 6
    const zoom = PIXI.Sprite.from('./zoom.svg')
    zoom.anchor.set(0.5)
    zoom.width = btnSize * 0.4
    zoom.height = btnSize * 0.4
    zoom.x = text.width * 0.5 + btnSize * 0.75
    zoom.y = 0
    frame.addChild(zoom)

    // 7
    const rotateLineContainer = new PIXI.Container()
    frame.addChild(rotateLineContainer)
    const rotateLine = new PIXI.Graphics()
    rotateLine.lineStyle(2, 0xffffff, 1)
    rotateLine.moveTo(0, -text.height * 0.5)
    rotateLine.lineTo(0, -text.height * 0.5 - btnSize * 0.75)
    rotateLineContainer.addChild(rotateLine)

    // 8
    const rotateBG = PIXI.Sprite.from('./circle.svg')
    rotateBG.tint = 0x0485d5
    rotateBG.anchor.set(0.5)
    rotateBG.width = btnSize
    rotateBG.height = btnSize
    rotateBG.x = 0
    rotateBG.y = -text.height * 0.5 - btnSize * 0.75
    rotateBG.interactive = true
    rotateBG.buttonMode = true
    rotateBG.on('pointerdown', (e) => {
      this.blurAction()
      this._rotating = true
      rotateBG._startAngle = container.angle
      rotateBG._startx = e.data.getLocalPosition(bg.parent.parent).x
    })
    rotateBG.on('pointermove', (e) => {
      if (!this._rotating) return
      container.angle = rotateBG._startAngle + (e.data.getLocalPosition(bg.parent.parent).x - rotateBG._startx) * 0.5
      if (this.update) {
        this.update()
      }
    })
    rotateBG.on('pointerup', () => {
      this._rotating = false
    })
    rotateBG.on('pointerupoutside', () => {
      this._rotating = false
    })
    frame.addChild(rotateBG)

    // 9
    const rotate = PIXI.Sprite.from('./rotate.svg')
    rotate.anchor.set(0.5)
    rotate.width = btnSize * 0.5
    rotate.height = btnSize * 0.5
    rotate.x = 0
    rotate.y = -text.height * 0.5 - btnSize * 0.75
    frame.addChild(rotate)

    // 10
    const editLineContainer = new PIXI.Container()
    frame.addChild(editLineContainer)
    const editLine = new PIXI.Graphics()
    editLine.lineStyle(2, 0xffffff, 1)
    editLine.moveTo(0, text.height * 0.5)
    editLine.lineTo(0, text.height * 0.5 + btnSize * 0.75)
    editLineContainer.addChild(editLine)

    // 11
    const editBG = PIXI.Sprite.from('./circle.svg')
    editBG.tint = 0x0485d5
    editBG.anchor.set(0.5)
    editBG.width = btnSize
    editBG.height = btnSize
    editBG.x = 0
    editBG.y = text.height * 0.5 + btnSize * 0.75
    editBG.interactive = true
    editBG.buttonMode = true
    this._focus = false
    editBG.on('pointerdown', async () => {
      if (!this._focus) {
        this.updateInput()
        if (this.isPhone) {
          // 使用setTimeout会被浏览器拦截，iOS无法弹出键盘，使用nextTick没问题
          await window.vue.$nextTick()
          this.focusAction()
        } else {
          setTimeout(() => {
            this.focusAction()
          }, 300)
        }
      } else {
        this.blurAction()
      }
    })
    frame.addChild(editBG)

    // 12
    const edit = PIXI.Sprite.from('./edit.svg')
    this.edit = edit
    edit.anchor.set(0.5)
    edit.width = btnSize * 0.5
    edit.height = btnSize * 0.5
    edit.x = 0
    edit.y = text.height * 0.5 + btnSize * 0.75
    frame.addChild(edit)

    this.container = container
    this._line = line
    this._text = text
    this._bg = bg
  }

  blurAction () {
    if (!this._focus) return
    this.text.visible = true
    this.input.style.display = 'none'
    this._focus = false
    this.input.blur()
    this.edit.texture = PIXI.Texture.from('./edit.svg')
    if (this.blur) {
      this.blur()
    }
  }

  removeAction () {
    this.blurAction()
    this.container.visible = false
    this.visible = false
    this.input.style.display = 'none'
    if (this.remove) {
      this.remove()
    }
    this.destroy()
  }

  focusAction () {
    if (this._focus) return
    this.text.visible = false
    this.input.style.display = 'initial'
    this._focus = true
    this.input.focus()
    this.edit.texture = PIXI.Texture.from('./confirm.svg')
    if (this.focus) {
      this.focus()
    }
  }

  unhighlight () {
    this._frame.visible = false
    this.blurAction()
  }

  highlight () {
    this._frame.visible = true
  }

  change () {
    this._frame.getChildAt(0).removeChildAt(0)
    const line = new PIXI.Graphics()
    line.lineStyle(2, 0xffffff, 1)
    line.moveTo(-this._text.width * 0.5, -this._text.height * 0.5)
    line.lineTo(-this._text.width * 0.5, this._text.height * 0.5)
    line.lineTo(this._text.width * 0.5, this._text.height * 0.5)
    line.lineTo(this._text.width * 0.5, -this._text.height * 0.5)
    line.lineTo(-this._text.width * 0.5, -this._text.height * 0.5)
    this._frame.getChildAt(0).addChild(line)

    this._frame.getChildAt(1).removeChildAt(0)
    const removeLine = new PIXI.Graphics()
    removeLine.lineStyle(2, 0xffffff, 1)
    removeLine.moveTo(-this._text.width * 0.5, 0)
    removeLine.lineTo(-this._text.width * 0.5 - btnSize * 0.75, 0)
    this._frame.getChildAt(1).addChild(removeLine)
    this._frame.getChildAt(2).x = -this._text.width * 0.5 - btnSize * 0.75
    this._frame.getChildAt(3).x = -this._text.width * 0.5 - btnSize * 0.75

    this._frame.getChildAt(4).removeChildAt(0)
    const zoomLine = new PIXI.Graphics()
    zoomLine.lineStyle(2, 0xffffff, 1)
    zoomLine.moveTo(this._text.width * 0.5, 0)
    zoomLine.lineTo(this._text.width * 0.5 + btnSize * 0.75, 0)
    this._frame.getChildAt(4).addChild(zoomLine)
    this._frame.getChildAt(5).x = this._text.width * 0.5 + btnSize * 0.75
    this._frame.getChildAt(6).x = this._text.width * 0.5 + btnSize * 0.75

    this._frame.getChildAt(7).removeChildAt(0)
    const rotateLine = new PIXI.Graphics()
    rotateLine.lineStyle(2, 0xffffff, 1)
    rotateLine.moveTo(0, -this._text.height * 0.5)
    rotateLine.lineTo(0, -this._text.height * 0.5 - btnSize * 0.75)
    this._frame.getChildAt(7).addChild(rotateLine)
    this._frame.getChildAt(8).y = -this._text.height * 0.5 - btnSize * 0.75
    this._frame.getChildAt(9).y = -this._text.height * 0.5 - btnSize * 0.75

    this._frame.getChildAt(10).removeChildAt(0)
    const editLine = new PIXI.Graphics()
    editLine.lineStyle(2, 0xffffff, 1)
    editLine.moveTo(0, this._text.height * 0.5)
    editLine.lineTo(0, this._text.height * 0.5 + btnSize * 0.75)
    this._frame.getChildAt(10).addChild(editLine)
    this._frame.getChildAt(11).y = this._text.height * 0.5 + btnSize * 0.75
    this._frame.getChildAt(12).y = this._text.height * 0.5 + btnSize * 0.75

    this._bg.width = this._text.width
    this._bg.height = this._text.height

    if (this.update) {
      this.update()
    }
  }

  updateInput () {
    // 更新input
    this.input.value = this.text.text
    this.input.style.fontFamily = this.text.style.fontFamily
    this.input.style.fontStyle = this.text.style.fontStyle
    this.input.style.fontWeight = this.text.style.fontWeight
    this.input.style.fontSize = this.text.style.fontSize + 'px'
    this.input.style.color = this.text.style.fill
    this.input.style.width = this.text.width + 'px'
    this.input.style.height = this.text.height + 'px'
    this.input.style.lineHeight = this.text.height + 'px'
    this.input.style.left = (window.innerWidth - this.text.width) * 0.5 + this.container.x + 'px'
    this.input.style.top = (innerHeight - this.text.height * fix - screenOffsetY) * 0.5 + this.container.y + 'px'
    this.input.style.transform = `rotate(${this.container.angle}deg)`
  }

  resize (val) {
    if (val == null) return
    this.text.style.fontSize *= val
    this.change()
  }

  move ({ x, y }) {
    this.container.x = x
    this.container.y = y
    this.change()
  }

  rotate (val) {
    this.container.angle = val
    if (this.update) {
      this.update()
    }
  }

  destroy () {
    if (this.input) {
      document.body.removeChild(this.input)
      this.input = null
    }
  }
}

export default MyPIXIText
